import request from "@/request/request";

const post = (url, data) => {
 return request({
  method: 'post',
  url,
  data
 })
}

const get = (url, data) => {
 return request({
  method: 'get',
  url,
  params: data
 })
}

export default {
 post,
 get
}